import { ExecutedMoovInstanceDTO } from "../DTO/executedMoovInstanceDTO";
import { Customer } from "./customer";

export class ExecutedMoovInstance{

    public id!: number;
    public customerId!: number;
    public customer!: Customer;
    public status!: number;
    public awaitingApproval!: boolean;
    public moovDefinitionName!: string;
    public moovDefinitionId!: number;
    public moovConfigurationId!: number;
    public sourceFilename!: string;
    public resultFilename!: string;
    public moovFileId!: number;
    public added!: Date;
    public completedAt!: Date;
    public filePurgeAfter!: Date;
    public filePurgedAt!: Date;

    public static mapFromDTO(param:ExecutedMoovInstanceDTO):ExecutedMoovInstance{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ExecutedMoovInstance();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.status = param.status;
            obj.awaitingApproval = param.awaitingApproval;
            obj.moovDefinitionName = param.moovDefinitionName;
            obj.moovDefinitionId = param.moovDefinitionId;
            obj.moovConfigurationId = param.moovConfigurationId;
            obj.sourceFilename = param.sourceFilename;
            obj.resultFilename = param.resultFilename;
            obj.moovFileId = param.moovFileId;
            obj.added = new Date(param.added);
            if(param.completedAt) obj.completedAt = new Date(param.completedAt);
            obj.filePurgeAfter = new Date(param.filePurgeAfter);
            if(param.filePurgedAt)obj.filePurgedAt = new Date(param.filePurgedAt);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ExecutedMoovInstance):ExecutedMoovInstanceDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ExecutedMoovInstanceDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.status = param.status;
            dto.awaitingApproval = param.awaitingApproval;
            dto.moovDefinitionName = param.moovDefinitionName;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.sourceFilename = param.sourceFilename;
            dto.resultFilename = param.resultFilename;
            dto.moovFileId = param.moovFileId;
            dto.added = param.added.toISOString();
            if(param.completedAt)  dto.completedAt = param.completedAt.toISOString();
            dto.filePurgeAfter = param.filePurgeAfter.toISOString();
            if(param.filePurgedAt) dto.filePurgedAt = param.filePurgedAt.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 0:
                return "created";
            case 1:
                return "processing";
            case 2:
                return "completed";
            case 3:
                return "failed";
            case 4:
                return "deleted";
            case 5:
                return "suspended";
            default:
                return "unknown";
        }
    }

    get statusColor(){
        if(this.status==0 || this.status==1 || this.status==5) return "blue";
        if(this.status==3) return "red";
        return "black";
    }
}